import React from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import { DEFAULT_QUERY_FIELDS, DEFAULT_QUERY_INPUT_VAR, DEFAULT_QUERY_INPUT } from './index';

  

const QUERY = (whatToPull=DEFAULT_QUERY_FIELDS)=> gql`
  query GetAll(
    ${DEFAULT_QUERY_INPUT_VAR} 
  ){
    giveawayConts(
      query:{
        ${DEFAULT_QUERY_INPUT}
      }
    ){
      _id
      ${whatToPull}
    }
  }
`;


const QUERYANDCOUNT = (whatToPull=DEFAULT_QUERY_FIELDS)=> gql`
  query GetAllNCount(
    ${DEFAULT_QUERY_INPUT_VAR} 
  ){
    giveawayContCount(
      query:{
        ${DEFAULT_QUERY_INPUT}
      }
    )
    giveawayConts(
      query:{
        ${DEFAULT_QUERY_INPUT}
      }
    ){
      _id
      ${whatToPull}
    }
  }
`;


const COUNT = (whatToPull=DEFAULT_QUERY_FIELDS)=> gql`
  query GetCount(
   ${DEFAULT_QUERY_INPUT_VAR} 
  ){
    giveawayContCount(
      query:{
        ${DEFAULT_QUERY_INPUT}
      }
    )
  }
`;


const QUERY_SINGLE = (whatToPull=DEFAULT_QUERY_FIELDS)=> gql`
  query Single($id: String){
    giveawayCont(id:$id){
      _id
      ${whatToPull}
    }
  }
`;



const QUERY_GET_DISTINCT = (whatToPull=DEFAULT_QUERY_FIELDS) => gql`
  query ListDistinct($field: String!){
    giveawayContDistinct(field:$field)
  }
`;



const QUERY_CHECK_EMAIL_EXIST = (whatToPull=DEFAULT_QUERY_FIELDS) => gql`
  query GiveawayContEmailChecker($email: String!, $GID: String!){
    giveawayContEmailChecker(email:$email, GID:$GID)
  }
`;



const QUERIES = {
  all: QUERY,
  allAndCount: QUERYANDCOUNT,
  count: COUNT,
  single: QUERY_SINGLE,
  distinct: QUERY_GET_DISTINCT,
  emailChecker: QUERY_CHECK_EMAIL_EXIST
}


export default QUERIES;